import React, {useCallback} from 'react';
import {usePlaidLink} from 'react-plaid-link';
import {PaymentDetails} from "./PaymentDetailsContainer";
import {ClickableText} from "../custom-common";

const PlaidMicroDeposits = ({setPlaidData, plaidLinkToken, plaidEnviroment, verificationStatus}) => {
    const {
        microDepositsBankAccountPmData,
        setMicroDepositsBankAccountPm,
    } = PaymentDetails.useContainer();

    const onSuccess = useCallback((_, data) => {
        data.metadata = {"verificationStatus": "manually_verified"}
        setPlaidData(data)
    }, [setPlaidData])

    const onExit = useCallback((error) => {
        console.log(error)
        if(error?.error_code === 'TOO_MANY_VERIFICATION_ATTEMPTS'){
            setMicroDepositsBankAccountPm({...microDepositsBankAccountPmData, status: "verification_failed"})
        }
    }, [microDepositsBankAccountPmData, setMicroDepositsBankAccountPm]);

    const config = {
        token: plaidLinkToken,
        env: plaidEnviroment,
        onSuccess,
        onExit,
    }

    const {open} = usePlaidLink(config)

    if (verificationStatus === 'Pending verification') {
        return (<>
            <span className={'plaidMicroDeposits'}>
                <ClickableText onClick={() => open()} small>
                    Verify account
                </ClickableText>
            </span>
        </>)
    }
    return null
}

export default PlaidMicroDeposits